import { defineComponent as e } from "vue";
const r = e({
  name: "CSRPhoneNumber",
  props: {
    showPhoneHours: {
      type: Boolean,
      default: !0
    },
    phoneNumber: {
      type: String,
      required: !0
    },
    phoneHours: {
      type: String,
      required: !1
    }
  },
  computed: {
    phoneNumberLink: function() {
      return `tel:+${this.phoneNumber}`;
    }
  }
});
export {
  r as default
};
//# sourceMappingURL=index2.js.map
